import { render, staticRenderFns } from "./LayerTree.vue?vue&type=template&id=45165c6e&"
import script from "./LayerTree.vue?vue&type=script&lang=js&"
export * from "./LayerTree.vue?vue&type=script&lang=js&"
import style0 from "./LayerTree.vue?vue&type=style&index=0&id=45165c6e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports